{
    "locale": "zh-tw",
    "title": {
      "zh-tw": "AD-8 極早期失智症篩檢量表"
    },
    "description": {
      "zh-tw": "AD-8量表用於民眾自我評估、專業人員親自詢問或電話中作答。在回答問題上，家屬應該依照患者過去與現在改變的狀況來考量，而患者本身也需依照自己過去與現在改變狀況來回答，而不是以自己目前的平常表現及來回應。AD-8量表提供極早期失智症的篩檢，其中最主要的包含了阿茲海默症、血管性失智症等較常見的疾病症狀。在計分時是以【有改變】當做計分的依準，若您以前無下列問題，但在過去幾年中有以下的『改變』，請勾選【有改變】；若無，請勾選【無改變】；若不確定，請勾選【不知道】。"
    },
    "pages": [
      {
        "name": "page4",
        "elements": [
          {
            "type": "text",
            "name": "date",
            "title": {
              "zh-tw": "填表日期"
            },
            "isRequired": true,
            "inputType": "date"
          },
          {
            "type": "radiogroup",
            "name": "fillingLocation",
            "title": {
              "zh-tw": "填表地點"
            },
            "isRequired": true,
            "choices": [
              {
                "value": 1,
                "text": {
                  "zh-tw": "衛生所"
                }
              },
              {
                "value": 2,
                "text": {
                  "zh-tw": "醫療院所"
                }
              },
              {
                "value": 3,
                "text": {
                  "zh-tw": "社區服務據點"
                }
              }
            ],
            "showOtherItem": true,
            "otherText": {
              "zh-tw": "其他"
            },
            "colCount": 2
          },
          {
            "type": "text",
            "name": "name",
            "title": {
              "zh-tw": "姓名"
            },
            "isRequired": true
          },
          {
            "type": "text",
            "name": "IdentityNumber",
            "title": {
              "zh-tw": "身分證統一編號"
            },
            "isRequired": true
          },
          {
            "type": "radiogroup",
            "name": "gender",
            "title": {
              "zh-tw": "性別"
            },
            "choices": [
              {
                "value": "1",
                "text": {
                  "zh-tw": "男"
                }
              },
              {
                "value": "2",
                "text": {
                  "zh-tw": "女"
                }
              }
            ],
            "colCount": 2
          },
          {
            "type": "text",
            "name": "birthday",
            "title": {
              "zh-tw": "出生年月日"
            },
            "isRequired": true,
            "inputType": "date"
          },
          {
            "type": "text",
            "name": "address",
            "title": {
              "zh-tw": "居住地址"
            },
            "isRequired": true,
            "autocomplete": "street-address"
          },
          {
            "type": "radiogroup",
            "name": "isAboriginal",
            "title": {
              "zh-tw": "是否為原住民"
            },
            "isRequired": true,
            "choices": [
              {
                "value": true,
                "text": {
                  "zh-tw": "是"
                }
              },
              {
                "value": false,
                "text": {
                  "zh-tw": "否"
                }
              }
            ]
          },
          {
            "type": "panel",
            "name": "contactNumber",
            "title": {
              "zh-tw": "聯絡電話"
            },
            "isRequired": true,
            "elements": [
              {
                "type": "text",
                "name": "Telephone",
                "title": {
                  "zh-tw": "家用"
                },
                "inputType": "tel"
              },
              {
                "type": "text",
                "name": "CellPhone",
                "title": {
                  "zh-tw": "手機"
                },
                "inputType": "tel"
              }
            ]
          },
          {
            "type": "dropdown",
            "name": "educationLevel",
            "title": {
              "zh-tw": "教育程度"
            },
            "isRequired": true,
            "choices": [
              {
                "value": 1,
                "text": {
                  "zh-tw": "未就學"
                }
              },
              {
                "value": 2,
                "text": {
                  "zh-tw": "國小畢(肄)"
                }
              },
              {
                "value": 3,
                "text": {
                  "zh-tw": "國中畢(肄)"
                }
              },
              {
                "value": 4,
                "text": {
                  "zh-tw": "高中畢(肄)"
                }
              },
              {
                "value": 5,
                "text": {
                  "zh-tw": "大學畢(肄)"
                }
              }
            ]
          },
          {
            "type": "radiogroup",
            "name": "hasFilledInLastYear",
            "title": {
              "zh-tw": "※最近 1 年內是否曾經填寫過此篩檢量表?"
            },
            "isRequired": true,
            "choices": [
              {
                "value": true,
                "text": {
                  "zh-tw": "是"
                }
              },
              {
                "value": false,
                "text": {
                  "zh-tw": "否"
                }
              }
            ]
          }
        ]
      },
      {
        "name": "page1",
        "elements": [
          {
            "type": "panel",
            "name": "panel3",
            "description": {
              "zh-tw": "填表說明：若您以前無下列問題，但在過去幾年中有以下的改變，請勾選「是，有改變」。\n若無，請勾選「不是，沒有改變」；若不確定，請勾「不知道」"
            },
            "elements": [
              {
                "type": "radiogroup",
                "name": "JudgmentDifficulties",
                "title": {
                  "zh-tw": "判斷力上的困難：例如落入圈套或騙局、財務上不好的決定、買了對受禮者不合宜的禮物。"
                },
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": {
                      "zh-tw": "有改變"
                    }
                  },
                  {
                    "value": 0,
                    "text": {
                      "zh-tw": "無改變"
                    }
                  },
                  {
                    "value": 2,
                    "text": {
                      "zh-tw": "不知道（不適用）"
                    }
                  }
                ],
                "colCount": 3
              },
              {
                "type": "radiogroup",
                "name": "InterestInActivities",
                "title": {
                  "zh-tw": "對活動和嗜好的興趣降低。"
                },
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": {
                      "zh-tw": "有改變"
                    }
                  },
                  {
                    "value": 0,
                    "text": {
                      "zh-tw": "無改變"
                    }
                  },
                  {
                    "value": 2,
                    "text": {
                      "zh-tw": "不知道（不適用）"
                    }
                  }
                ],
                "colCount": 3
              },
              {
                "type": "radiogroup",
                "name": "RepeatingQuestions",
                "title": {
                  "zh-tw": "重複相同的問題、故事和陳述。"
                },
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": {
                      "zh-tw": "有改變"
                    }
                  },
                  {
                    "value": 0,
                    "text": {
                      "zh-tw": "無改變"
                    }
                  },
                  {
                    "value": 2,
                    "text": {
                      "zh-tw": "不知道（不適用）"
                    }
                  }
                ],
                "colCount": 3
              },
              {
                "type": "radiogroup",
                "name": "UsingToolsDifficulties",
                "title": {
                  "zh-tw": "學習如何使用工具、設備、和小器具上有困難，例如：電視、音響、遙控器、冷氣機、洗衣機、熱水器、微波爐等。"
                },
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": {
                      "zh-tw": "有改變"
                    }
                  },
                  {
                    "value": 0,
                    "text": {
                      "zh-tw": "無改變"
                    }
                  },
                  {
                    "value": 2,
                    "text": {
                      "zh-tw": "不知道（不適用）"
                    }
                  }
                ],
                "colCount": 3
              },
              {
                "type": "radiogroup",
                "name": "ForgettingMonthYear",
                "title": {
                  "zh-tw": "忘記正確的月份和年份。"
                },
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": {
                      "zh-tw": "有改變"
                    }
                  },
                  {
                    "value": 0,
                    "text": {
                      "zh-tw": "無改變"
                    }
                  },
                  {
                    "value": 2,
                    "text": {
                      "zh-tw": "不知道（不適用）"
                    }
                  }
                ],
                "colCount": 3
              },
              {
                "type": "radiogroup",
                "name": "HandlingComplexFinancialIssues",
                "title": {
                  "zh-tw": "處理複雜的財務上有困難，例如：個人或家庭的收支平衡、繳費單、所得稅等。"
                },
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": {
                      "zh-tw": "有改變"
                    }
                  },
                  {
                    "value": 0,
                    "text": {
                      "zh-tw": "無改變"
                    }
                  },
                  {
                    "value": 2,
                    "text": {
                      "zh-tw": "不知道（不適用）"
                    }
                  }
                ],
                "colCount": 3
              },
              {
                "type": "radiogroup",
                "name": "RememberingAppointments",
                "title": {
                  "zh-tw": "記住約會的時間有困難。"
                },
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": {
                      "zh-tw": "有改變"
                    }
                  },
                  {
                    "value": 0,
                    "text": {
                      "zh-tw": "無改變"
                    }
                  },
                  {
                    "value": 2,
                    "text": {
                      "zh-tw": "不知道（不適用）"
                    }
                  }
                ],
                "colCount": 3
              },
              {
                "type": "radiogroup",
                "name": "ThinkingMemoryIssues",
                "title": {
                  "zh-tw": "有持續的思考和記憶方面的問題。"
                },
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": {
                      "zh-tw": "有改變"
                    }
                  },
                  {
                    "value": 0,
                    "text": {
                      "zh-tw": "無改變"
                    }
                  },
                  {
                    "value": 2,
                    "text": {
                      "zh-tw": "不知道（不適用）"
                    }
                  }
                ],
                "colCount": 3
              }
            ]
          }
        ]
      },
      {
        "name": "page2",
        "elements": [
          {
            "type": "panel",
            "name": "panel1",
            "title": {
              "zh-tw": "＊若量表總得分大於或等於 2 分，您可能需要透過更詳細的檢查，由專業醫師進行診斷。\n 桃園市政府衛生局 關心您"
            },
            "elements": [
              {
                "type": "text",
                "name": "totalCounts",
                "title": {
                  "zh-tw": "總分"
                },
                "defaultValueExpression": "iif({JudgmentDifficulties} == 1, 1, 0) + iif({InterestInActivities} == 1, 1, 0) + iif({RepeatingQuestions} == 1, 1, 0) + iif({UsingToolsDifficulties} == 1, 1, 0) + iif({ForgettingMonthYear} == 1, 1, 0) + iif({HandlingComplexFinancialIssues} == 1, 1, 0) + iif({RememberingAppointments} == 1, 1, 0) + iif({ThinkingMemoryIssues} == 1, 1, 0)",
                "readOnly": true
              },
              {
                "type": "text",
                "name": "screeningUnit",
                "title": {
                  "zh-tw": "篩檢單位"
                },
                "isRequired": true
              },
              {
                "type": "text",
                "name": "screeningStaff",
                "title": {
                  "zh-tw": "篩檢人員"
                },
                "isRequired": true
              }
            ]
          }
        ]
      }
    ],
    "questionErrorLocation": "bottom",
    "widthMode": "static",
    "width": "48rem"
}
